<template>
	<div class="company-profile">
		<DxLoadPanel v-model:visible="isLoading" />
		<div style="background:rgba(18,72,173,1);color:#eee;padding:30px 50px;border-bottom:5px solid rgba(0,0,0,0.15);display:flex;vertical-align:middle;column-gap:20px;">
			<div><img :src="logoSrc" style="height:100px;width:100px;"></div>
			<div>
				<div style="font-size:2em;">{{ companyProfile.name }}</div>
				<div>{{ companyProfile.address }}</div>
				<div>{{ companyProfile.region }}, {{ companyProfile.country }}</div>
			</div>
		</div>
		<div style="display:flex;">
			<div style="flex:1;padding: 30px 50px;">
				<div>About Company</div>
				<div>{{ companyProfile.about_company }}</div>
				<div>Benefits</div>
				<div>{{ companyProfile.benefits }}</div>
			</div>
			<div style="width:max(40%, 200px);padding: 30px 50px;">
				<DxTileView :data-source="galleryItems" :height="400" :base-item-height="200" :base-item-width="200" :item-margin="10" :show-scrollbar="true">
					<template #item="{ data }">
						<div style="height:100%;width:100%;">
							<img v-if="data.filemime.startsWith('image')"  :src="AppInfo.storageURL + '/' + data.store" style="width:100%;height:100%;object-fit:cover;">
							<video v-else-if="data.filemime.startsWith('video')" :src="AppInfo.storageURL + '/' + data.store" controls style="width:100%;height:100%;object-fit:cover;">
								Your browser does not support the video tag.
							</video>
						</div>
					</template>
				</DxTileView>
			</div>
		</div>
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, computed } from 'vue'
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxBox, DxItem } from 'devextreme-vue/box';
import { sizes } from "../utils/media-query";
import { DxTileView } from 'devextreme-vue/tile-view';
import DxBullet, { DxSize } from 'devextreme-vue/bullet';
import { DxPopover } from 'devextreme-vue/popover';
import AppInfo from "../app-info.js";

const isLoading = ref(false);
const isTiny = sizes()["screen-x-small"];
const isSmall = sizes()["screen-small"];
const isMedium = sizes()["screen-medium"];

const companyProfile = ref({
	id: 1,
	uuid: 'uuid-uuid-uuid',
	name: "St. Luke's Medical Center",
	website: 'https://www.stlukesmedicalcenter.com',
	address: '279 E Rodriguez Sr. Ave, Quezon City, 1112 Metro Manila, Philippinen',
	region: 'Metro Manila',
	country: 'Philippines',
	telephone: '+63 2 893 0000',
	email: 'info@stlukesmedicalcenter.com',
	about_company: "St. Luke's Medical Center is a private hospital in Quezon City, Philippines. It is one of the largest hospitals in the country and is known for its high-quality medical services.",
	benefits: "St. Luke's Medical Center offers a wide range of benefits to its employees, including competitive salary, medical insurance, and retirement benefits.",
	user_id: 1,
	created_at: '2024-01-01 00:00:00',
	updated_at: '2024-03-01 00:00:00',
	attachments: [
		{ id: 122, user_id: 1, filename: 'logo.png', filesize: 123456, filemime: 'image/jpeg', store: 'logo.png', scope: 'logo' },
		{ id: 123, user_id: 1, filename: 'gallery1.jpg', filesize: 123456, filemime: 'image/jpeg', store: 'gallery1.jpg', scope: 'gallery' },
		{ id: 124, user_id: 1, filename: 'gallery2.jpg', filesize: 123456, filemime: 'image/jpeg', store: 'gallery2.jpg', scope: 'gallery' },
		{ id: 125, user_id: 1, filename: 'gallery3.jpg', filesize: 123456, filemime: 'image/jpeg', store: 'gallery3.jpg', scope: 'gallery' },
		{ id: 126, user_id: 1, filename: 'gallery4.jpg', filesize: 123456, filemime: 'image/jpeg', store: 'gallery4.jpg', scope: 'gallery' },
		{ id: 127, user_id: 1, filename: 'gallery5.jpg', filesize: 123456, filemime: 'image/jpeg', store: 'gallery5.jpg', scope: 'gallery' },
		{ id: 128, user_id: 1, filename: 'gallery6.mp4', filesize: 123456, filemime: 'video/mp4', store: 'gallery6.mp4', scope: 'gallery' },
		{ id: 129, user_id: 1, filename: 'gallery7.mp4', filesize: 123456, filemime: 'video/mp4', store: 'gallery7.mp4', scope: 'gallery' },
		{ id: 130, user_id: 1, filename: 'attach1.pdf', filesize: 123456, filemime: 'application/pdf', store: 'attach1.pdf', scope: 'about_company' },
		{ id: 131, user_id: 1, filename: 'attach2.pdf', filesize: 123456, filemime: 'application/pdf', store: 'attach2.pdf', scope: 'about_company' },
		{ id: 132, user_id: 1, filename: 'attach3.png', filesize: 123456, filemime: 'image/png', store: 'attach3.png', scope: 'about_company' },
		{ id: 133, user_id: 1, filename: 'attach4.png', filesize: 123456, filemime: 'image/png', store: 'attach4.png', scope: 'benefits' },
		{ id: 134, user_id: 1, filename: 'attach5.pdf', filesize: 123456, filemime: 'application/pdf', store: 'attach5.pdf', scope: 'benefits' },
	],
});

const logoSrc = computed(() => {
	let logoAttachment = companyProfile.value?.attachments?.find(attachment => attachment.scope === 'logo')?.store ?? null;
	return logoAttachment ? `${AppInfo.storageURL}/${logoAttachment}` : '';
});

const galleryItems = computed(() => {
	return companyProfile.value?.attachments?.filter(attachment => attachment.scope === 'gallery') ?? [];
});

</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
.company-profile {
	background: rgb(0,58,168);
	background: linear-gradient(150deg, rgba(0,58,168,1) 0%, rgba(238,238,238,1) 55%);
	min-height: 100vh;
}
</style>